import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Dimension {
  name: string
  size: number
}

interface Variable {
  name: string
  dimensions: string[]
  attributes: Record<string, any>
  type: string
}

interface Dataset {
  id: string
  name: string
  type: 'nc' | 'csv' | 'xlsx'
  data: string | ArrayBuffer
  metadata?: {
    dimensions?: Array<{
      name: string
      size: number
    }>
    variables?: Array<{
      name: string
      dimensions: string[]
      attributes: Record<string, unknown>
      type: string
    }>
    attributes?: {
      rowCount?: number
      columnCount?: number
      parsedData?: Record<string, unknown>[]
      fields?: string[]
      sheets?: string[]  // For Excel files
      dimensions?: Record<string, unknown>  // For NetCDF files
    }
    sheets?: string[]  // For Excel files
  }
}

interface APIConfig {
  endpoint: string
  apiKey: string
  isConnected: boolean
}

interface DataStore {
  datasets: Dataset[]
  apiConfig: APIConfig | null
  addDataset: (dataset: Dataset) => void
  removeDataset: (id: string) => void
  setAPIConfig: (config: APIConfig) => void
  clearAPIConfig: () => void
}

export const useDataStore = create<DataStore>()(
  persist(
    (set) => ({
      datasets: [],
      apiConfig: null,
      addDataset: (dataset: Dataset) => {
        console.log('Store: Adding dataset', {
          id: dataset.id,
          name: dataset.name,
          parsedData: dataset.metadata?.attributes?.parsedData?.[0],
          fields: dataset.metadata?.attributes?.fields
        })
        set((state) => ({
          datasets: [...state.datasets, dataset]
        }))
      },
      removeDataset: (id) =>
        set((state) => ({
          datasets: state.datasets.filter((d) => d.id !== id)
        })),
      setAPIConfig: (config) =>
        set(() => ({
          apiConfig: config
        })),
      clearAPIConfig: () =>
        set(() => ({
          apiConfig: null
        })),
    }),
    {
      name: 'dtaas-storage', // unique name for localStorage key
      partialize: (state) => ({
        // Only persist these fields
        datasets: state.datasets,
        apiConfig: state.apiConfig
      })
    }
  )
)

// Export types for use in other files
export type { Dimension, Variable, Dataset, APIConfig }
